import React from 'react';
import '../../styles/pages/Instructions.scss';

const PricingInstructions: React.FC = () => {
    return (
        <div className="container">
            <h1>Item Price Lookup from WMJ Pricing</h1>
            <p>Once you have completed your item lookup, you can use our item pricing spreadsheet to find the latest auction prices from Wine Market Journal. You can download the spreadsheet template here: 
                
                <a href="https://zachys.sharepoint.com/:x:/s/ZachysCommunity/EazxMu1rB8lMjsP5g5QBdzgBfNCA8JoG3ZViISEF6kDqhQ?e=zg94PR" target='_blank' download>Item Pricing Template</a>.</p>
            <h2>Instructions</h2>
            <ol>
                <li>Download the Excel template above and save it to your local PC.</li>
                <li>To use the spreadsheet, you must enable its advanced macros. Navigate to the folder containing the spreadsheet using File Explorer to do this.
                     <br></br>a. Right-click on the downloaded Excel file.
                     <br></br>b. Select "Properties".
                     <br></br>c. Under the "General" tab, check the "Unblock" box (if available).
                     <br></br>d. Click "Apply" and then "OK".
                </li>
                    
                <li>Open the results tab from the attribute application Excel results and copy all the data from the results tab.</li>
                <img src="../instructions/pricinginstruction_result.png" alt="result tab" />
                <li>Paste those results into the Results tab of the pricing spreadsheet.</li>
                <img src="../instructions/pricinginstruction_result2.png" alt="result tab" />
                <li>Once pasted, go to the WMJ Pricing sheet in that workbook.</li>
                <li>Click the Run API button.</li>
                <img src="../instructions/pricinginstruction_result3.png" alt="result tab" />
                <li>The results will populate.</li>
            </ol>

            <p>Depending on the number of rows, it may take several minutes for the results to populate.</p>
            <br></br><p>If you are not seeing the results you expect, you can adjust the settings the sheet uses to retrieve the data. To adjust the settings, click the Dashboard Tab of the spreadsheet. These are the settings that can be adjusted: </p>
            <br></br><p>Number of Days: Choose a value between 1 and 1000. This is how far back the application will look to find the latest auction pricing.</p>
            <br></br><p>Continent: This will limit your results to auctions that took place in the selected location. Acceptable Continent Inputs:</p>
            <p>
                (blank) = ALL Continents 
                <br></br> Internet 
                <br></br> North America 
                <br></br> Europe 
                <br></br> Asia 
                <br></br> Australia 
            </p>
        </div>
    );
};

export default PricingInstructions;